export const DOCUMENT_MAP_VIEW_MODES = ["list", "split", "map"] as const;

export type DocumentMapViewMode = (typeof DOCUMENT_MAP_VIEW_MODES)[number];

/** Tailwind classes of a node class. */
export interface ClassStyle {
  label: string;
  /** Fill of the class label, on a white box. */
  fill: string;
  border: string;
  text: string;
}
